export enum BidCommitteeStatusId {
	New = 1,
	Draft = 2,
	InvitationsSent = 3,
	Active = 4,
	Inactive = 5,
	TermExpired = 6,
	Terminated = 7,
	OnHold = 8,
}

export enum BidCommitteeStatusName {
	New = "New",
	Draft = "Draft",
	InvitationsSent = "Invitations Sent",
	Active = "Active",
	Inactive = "Inactive",
	TermExpired = "Term Expired",
	Terminated = "Terminated",
	OnHold = "On Hold",
}

export enum BidCommitteeConfirmationType {
	Accept = "accept-appointment",
	Decline = "decline-appointment",
	View = "view",
}
